import React from "react";
import { Button, ButtonProps } from "@cmp-src/primitives/button";

export type ModalActionButtonProps = ButtonProps;

export const ModalActionButton: React.FC<ModalActionButtonProps> = ({
  ...rest
}) => {
  return <Button className="w-full sm:w-auto" {...rest} />;
};
